import { VENDOR_PRODUCTS_RECEIVED } from '../../actions/product-management/GetVendorProducts';

const initialState = [];

const vendorProducts = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_PRODUCTS_RECEIVED:
      return action.products;
  }

  return state;
};

export default vendorProducts;
